import React from 'react';


const Junkmailmodal = (proos) => {
const {modalRefs} = proos
  return (
<div
  ref={(el) => (modalRefs.current["junkemailmodal"] = el)}
  className="modal fade"
  id="junkemailmodal"
  tabIndex="-1"
  aria-labelledby="junkemailmodalLabel"
  aria-hidden="true"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
>
  <div className="modal-dialog modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-body position-relative">
        {/* Top-right X icon */}
        <button
          type="button"
          className="btn-close position-absolute top-0 end-0 m-2"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>

        <h5 className="modal-title mb-3">Please check junk and spam folder</h5>
        <p className="text-muted">
          Sometimes emails may land in spam. Be sure to check your junk folder.
        </p>
      </div>
    </div>
  </div>
</div>
  );
};

export default Junkmailmodal;